'use strict';

namespace Core {

    class BookingExtrasCarHireOption {

        quote: any;
        model: string;
        selectable: boolean;
        selectCar: (x: { quoteId: string }) => void;

        public select($event) {
            $event.preventDefault();
            this.selectCar( { quoteId : this.quote.CarHireId.CarHireCode });
        }

    }

    angular
        .module('TR')
        .directive('bookingExtrasCarHireOption', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                bindToController: {
                    quote: '=',
                    model: '=',
                    selectable: '=',
                    selectCar: '&'
                },
                controller: BookingExtrasCarHireOption,
                controllerAs: 'cho',
                templateUrl: 'partials/home/directivetemplate?type=BookingExtrasCarHireOption'
            };

        });

}
